import AuthSteps from 'components/collections/AuthSteps'
import { Button, Modal } from 'components/elements'
import { useSession } from 'context/Session'
import { useState } from 'react'
import styled from 'styled-components'

import CreateGroupForm from './CreateGroupForm'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 64px 160px 32px;
  ${({ theme }) => theme.media.desktop} {
    padding: 64px 60px 32px;
  }
  ${({ theme }) => theme.media.tablet} {
    padding: 56px 32px 28px;
    flex-direction: column;
  }
  ${({ theme }) => theme.media.phone} {
    padding: 30px 16px;
    flex-direction: column;
  }
`
export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  max-width: 1440px;
  ${({ theme }) => theme.media.tabletMini} {
    flex-direction: column;
  }
`

export const Title = styled.h1`
  ${({ theme }) => theme.font.h1}
  margin: 0;
  max-width: 1440px;
`

export const ButtonContainer = styled.div`
  width: 300px;
  ${({ theme }) => theme.media.tablet} {
    margin-top: 30px;
  }
`
const modalMap = {
  signUp: AuthSteps,
  group: CreateGroupForm,
}

export const CreateGroupButton = () => {
  const [isOpen, setOpen] = useState(false)
  const { accessToken } = useSession()
  const ModalComponent = modalMap[accessToken ? 'group' : 'signUp']

  const [
    modalConfig,
    //  setModalConfig
  ] = useState({})

  // const isStaff = verifyPermission(['Admin', 'Staff', 'SuperAdmin'])

  // if (isStaff) {
  //   const handleClose = () => {
  //     setAnchorEl(null)
  //   }
  //   const handleClick = event => {
  //     setAnchorEl(event.currentTarget)
  //   }
  //   return (
  //     <>
  //       <Button style={{ width: '100%' }} onClick={handleClick}>
  //         Create Group
  //       </Button>
  //       <Menu
  //         id="basic-menu"
  //         anchorEl={anchorEl}
  //         open={open}
  //         onClose={handleClose}
  //         MenuListProps={{
  //           'aria-labelledby': 'basic-button',
  //         }}
  //         anchorOrigin={{
  //           vertical: 'bottom',
  //           horizontal: 'center',
  //         }}
  //         transformOrigin={{
  //           vertical: 'top',
  //           horizontal: 'right',
  //         }}
  //       >
  //         <MenuItem
  //           onClick={() => {
  //             setModalConfig({
  //               asTSN: false,
  //             })
  //             setOpen(true)
  //             handleClose()
  //           }}
  //         >
  //           Ask
  //         </MenuItem>
  //         <MenuItem
  //           onClick={() => {
  //             setModalConfig({
  //               asTSN: true,
  //             })
  //             setOpen(true)
  //             handleClose()
  //           }}
  //         >
  //           Ask as TSN
  //         </MenuItem>
  //       </Menu>
  //       <Modal
  //         isOpen={isOpen}
  //         close={() => setOpen(false)}
  //         closeOnOutside={false}
  //       >
  //         <ModalComponent {...modalConfig} />
  //       </Modal>
  //     </>
  //   )
  // }

  return (
    <>
      <Button style={{ width: '100%' }} onClick={() => setOpen(true)}>
        Create Group
      </Button>
      <Modal
        isOpen={isOpen}
        close={() => setOpen(false)}
        closeOnOutside={false}
      >
        <ModalComponent {...modalConfig} />
      </Modal>
    </>
  )
}
